<div class="main-content">

  <div class="loading-overlay" *ngIf="isLoading">
    <div class="text-center">
      <div class="spinner-border text-primary" role="status"></div>
    </div>
  </div>

  <!-- Header -->
  <div class="header-section">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h1 class="main-title">Gestione Borderò</h1>
        <p class="main-subtitle">Gestisci, ricerca, stampa ed esporta borderò</p>
      </div>

      <div class="d-flex gap-2">
        <button class="btn btn-danger" (click)="openInvalidateParcelsPopup()">
          <i class="fas fa-ban me-1"></i> Invalida Colli
        </button>

        <button class="btn btn-primary" (click)="openCreatePopup()">
          <i class="fas fa-plus me-1"></i> Nuovo
        </button>
      </div>
    </div>


  </div>

  <!-- Filtri -->
  <div id="filters-section" class="card mb-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-filter header-icon"></i>
          <h3>Filtri e Azioni</h3>
        </div>

        <button type="button" class="btn btn-sm btn-outline-secondary"
                (click)="toggleFiltersCollapsed()">
          <i class="fas" [ngClass]="isFiltersCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
        </button>
      </div>
    </div>

    <div class="card-body" *ngIf="!isFiltersCollapsed">
      <div class="row g-3">
        <div class="col-md-4" *ngIf="warehouses.length > 1">
          <label class="form-label">Magazzino</label>

          <div class="filter-input-wrapper">

            <ng-select
              class="filter-ng-select filter-ng-select-warehouse"
              [class.is-invalid]="filterWarehouseInvalid"
              [items]="warehouses"
              bindLabel="warehouseName"
              bindValue="warehouseCode"
              [(ngModel)]="filterWarehouse"
              (ngModelChange)="onWarehouseChange()"
              [clearable]="true"
              [searchable]="true"
              [searchFn]="searchWarehouseFn"
              placeholder="Seleziona un magazzino">

              <ng-template ng-option-tmp let-item="item">
                <span class="status-option">
                  <i class="fas fa-warehouse me-2"></i>
                  <span>{{ item.warehouseName }} ({{ item.warehouseShortName }})</span>
                </span>
              </ng-template>

              <ng-template ng-label-tmp let-item="item">
                <span class="status-option">
                  <i class="fas fa-warehouse me-2"></i>
                  <span>{{ item.warehouseName }} ({{ item.warehouseShortName }})</span>
                </span>
              </ng-template>

            </ng-select>
          </div>

          <div class="invalid-feedback-custom" *ngIf="filterWarehouseInvalid">
            Magazzino obbligatorio.
          </div>
        </div>

        <div class="col-md-4">
          <label class="form-label">Intervallo date</label>

          <div class="mb-2 date-range-filter">
            <button class="shift-btn"
                    type="button"
                    (click)="shiftSelectedDates(-1)"
                    matTooltip="Indietro di 1 giorno"
                    matTooltipPosition="below"
                    matTooltipShowDelay="200">
              <i class="fa-solid fa-caret-left"></i>
            </button>

            <div class="date-range-inputs">
              <div class="filter-input-wrapper">
                <i class="fas fa-calendar-plus filter-icon"></i>
                <input type="date"
                      [(ngModel)]="selectedDateFromStr"
                      (ngModelChange)="onDateStringsChange()">
              </div>

              <div class="filter-input-wrapper">
                <i class="fas fa-calendar-check filter-icon"></i>
                <input type="date"
                      [(ngModel)]="selectedDateToStr"
                      (ngModelChange)="onDateStringsChange()">
              </div>
            </div>

            <button class="shift-btn"
                    type="button"
                    (click)="shiftSelectedDates(1)"
                    matTooltip="Avanti di 1 giorno"
                    matTooltipPosition="below"
                    matTooltipShowDelay="200">
              <i class="fa-solid fa-caret-right"></i>
            </button>

          </div>
        </div>


        <!-- <div class="col-md-2">
          <label class="form-label">Stato</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-flag filter-icon"></i>
            <select class="filter-select" [(ngModel)]="filterStatus">
              <option value="">Tutti</option>
              <option *ngFor="let s of availableStatuses" [value]="s.value">{{ s.label }}</option>
            </select>
          </div>
        </div> -->
        <div class="col-md-2">
          <label class="form-label">Stato</label>

          <div class="filter-input-wrapper">
            <i class="fas fa-flag filter-icon"></i>

            <ng-select
              class="filter-ng-select"
              [items]="availableStatuses"
              bindLabel="label"
              bindValue="value"
              [(ngModel)]="filterStatus"
              [clearable]="false"
              [searchable]="false">


              <ng-template ng-option-tmp let-item="item">
                <span class="status-option">
                  <i class="fas me-2" [ngClass]="item.icon" [style.color]="item.color"></i>
                  <span class="status-dot me-2" [style.background]="item.color"></span>
                  <span>{{ item.label }}</span>
                </span>
              </ng-template>

              <ng-template ng-label-tmp let-item="item">
                <span class="status-option">
                  <span class="status-dot " [style.background]="item.color"></span>
                  <span class="status-pill" [style.borderColor]="item.color">
                    <i class="fas me-2" [ngClass]="item.icon" [style.color]="item.color"></i>
                    <span class="status-dot me-2" [style.background]="item.color"></span>
                    <span>{{ item.label }}</span>
                  </span>
                </span>
              </ng-template>

            </ng-select>
          </div>
        </div>


        <div class="col-md-2">
          <label class="form-label">Tipo</label>

          <div class="filter-input-wrapper">
            <i class="fas fa-flag filter-icon"></i>

            <ng-select
              class="filter-ng-select"
              [items]="availableType"
              bindLabel="label"
              bindValue="value"
              [(ngModel)]="filterType"
              [clearable]="false"
              [searchable]="false">


              <ng-template ng-option-tmp let-item="item">
                <span class="status-option">

                  <ng-container *ngIf="item.icons; else singleIcon">
                    <ng-container *ngFor="let ic of item.icons">
                      <i class="fas me-2" [ngClass]="ic.icon" [style.color]="ic.color"></i>
                    </ng-container>
                  </ng-container>

                  <ng-template #singleIcon>
                    <i class="fas me-2" [ngClass]="item.icon" [style.color]="item.color"></i>
                  </ng-template>

                  <span>{{ item.label }}</span>

                </span>
              </ng-template>

              <ng-template ng-label-tmp let-item="item">
                <span class="status-option">

                  <span class="status-pill">

                    <ng-container *ngIf="item.icons; else singleIconLabel">
                      <ng-container *ngFor="let ic of item.icons">
                        <i class="fas me-2" [ngClass]="ic.icon" [style.color]="ic.color"></i>
                      </ng-container>
                    </ng-container>

                    <ng-template #singleIconLabel>
                      <i class="fas me-2" [ngClass]="item.icon" [style.color]="item.color"></i>
                    </ng-template>

                    <span>{{ item.label }}</span>
                  </span>

                </span>
              </ng-template>

            </ng-select>
          </div>
        </div>

        <div class="col-md-2">
          <label class="form-label">Codice Borderò</label>
          <input type="text" class="form-control" [(ngModel)]="searchLoadingListCode" />
        </div>

        <div class="col-md-2">
          <label class="form-label">Codice Collo</label>
          <input type="text" class="form-control" [(ngModel)]="searchParcelCode" />
        </div>

        <div class="col-md-4" *ngIf="warehouses.length > 1">
          <label class="form-label">Magazzino di partenza</label>

          <div class="filter-input-wrapper">
            <i class="fas fa-warehouse filter-icon"></i>

            <ng-select
              class="filter-ng-select"
              [items]="warehouses"
              bindLabel="warehouseName"
              bindValue="warehouseCode"
              [(ngModel)]="filterWarehouseFrom"
              [clearable]="true"
              [searchable]="true"
              [searchFn]="searchWarehouseFn"
              placeholder="Seleziona un magazzino di partenza">

              <ng-template ng-option-tmp let-item="item">
                <span class="status-option">
                  <span>{{ item.warehouseName }} ({{ item.warehouseShortName }})</span>
                </span>
              </ng-template>

              <ng-template ng-label-tmp let-item="item">
                <span class="status-option">
                  <span>{{ item.warehouseName }} ({{ item.warehouseShortName }})</span>
                </span>
              </ng-template>

            </ng-select>
          </div>
        </div>

        <div class="col-md-4" *ngIf="warehouses.length > 1">
          <label class="form-label">Magazzino di arrivo</label>

          <div class="filter-input-wrapper">
            <i class="fas fa-warehouse filter-icon"></i>

            <ng-select
              class="filter-ng-select"
              [items]="warehouses"
              bindLabel="warehouseName"
              bindValue="warehouseCode"
              [(ngModel)]="filterWarehouseTo"
              [clearable]="true"
              [searchable]="true"
              [searchFn]="searchWarehouseFn"
              placeholder="Seleziona un magazzino di arrivo">

              <ng-template ng-option-tmp let-item="item">
                <span class="status-option">
                  <span>{{ item.warehouseName }} ({{ item.warehouseShortName }})</span>
                </span>
              </ng-template>

              <ng-template ng-label-tmp let-item="item">
                <span class="status-option">
                  <span>{{ item.warehouseName }} ({{ item.warehouseShortName }})</span>
                </span>
              </ng-template>

            </ng-select>
          </div>
        </div>

      </div>

      <div class="mt-4 pt-3 border-top d-flex justify-content-end gap-2">
        <button class="btn btn-outline-secondary" (click)="resetFilters()">
          <i class="fas fa-undo me-1"></i> Reset
        </button>
        <button class="btn btn-primary" (click)="search()"
                [disabled]="isSearchLoading">
          <i class="fas" [ngClass]="isSearchLoading ? 'fa-spinner fa-spin' : 'fa-search'"></i>
          Cerca
        </button>
      </div>
    </div>
  </div>


<!-- Sezione Resoconto -->
<div id="summary-section" class="card mb-4">
  <div class="card-header">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-title">
        <i class="fas fa-chart-bar header-icon"></i>
        <h3>Resoconto</h3>
      </div>

      <button type="button"
              class="btn btn-sm btn-outline-secondary"
              (click)="toggleReportCollapsed()"
              [title]="isReportCollapsed ? 'Espandi' : 'Comprimi'">
        <i class="fas" [ngClass]="isReportCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
      </button>
    </div>
  </div>

  <div class="card-body" *ngIf="!isReportCollapsed">
  <div class="row g-3">

    <!-- BOZZA -->
    <div class="col-xl-3 col-lg-4 col-md-6">
      <div class="summary-card summary-card--wide d-flex align-items-center p-3 rounded"
           style="background-color: rgba(245, 121, 6, 0.10);">
        <div class="d-flex align-items-center">
          <i class="fas fa-pen fa-2x" style="color:#f57906;"></i>
          <div class="ms-3">
            <div class="fw-bold fs-4" style="color:#f57906;">{{ summaryDraft | number }}</div>
            <div class="fw-bold small" style="color:#f57906;">Bozze</div>
          </div>
        </div>

        <div class="ms-auto ps-3 border-start summary-metrics">
          <div class="d-flex gap-3">
            <div class="summary-metric">
              <div class="summary-metric__title text-muted">Colli in sospeso</div>
              <div class="summary-metric__value fw-semibold">{{ totDraftItems | number }}</div>
              <div class="summary-metric__sub text-muted">
                {{ formatKg(totDraftWeight) }} • {{ formatM3(totDraftVolume) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- PREPARATO -->
    <div class="col-xl-3 col-lg-4 col-md-6">
      <div class="summary-card summary-card--wide d-flex align-items-center p-3 rounded"
           style="background-color: rgba(41, 122, 245, 0.10);">
        <div class="d-flex align-items-center">
          <i class="fas fa-circle-check fa-2x" style="color:#297af5;"></i>
          <div class="ms-3">
            <div class="fw-bold fs-4" style="color:#297af5;">{{ summaryValidated | number }}</div>
            <div class="fw-bold small" style="color:#297af5;">Preparati</div>
          </div>
        </div>

        <div class="ms-auto ps-3 border-start summary-metrics">
          <div class="d-flex gap-3">
            <div class="summary-metric">
              <div class="summary-metric__title text-muted">Colli caricati</div>
              <div class="summary-metric__value fw-semibold">{{ totPreparedItems | number }}</div>
              <div class="summary-metric__sub text-muted">
                {{ formatKg(totPreparedWeight) }} • {{ formatM3(totPreparedVolume) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ARRIVATO -->
    <div class="col-xl-3 col-lg-4 col-md-6">
      <div class="summary-card summary-card--wide d-flex align-items-center p-3 rounded"
           style="background-color: rgba(13, 202, 240, 0.10);">
        <div class="d-flex align-items-center">
          <i class="fas fa-circle-down fa-2x" style="color:#0dcaf0;"></i>
          <div class="ms-3">
            <div class="fw-bold fs-4" style="color:#0dcaf0;">{{ summaryArrived | number }}</div>
            <div class="fw-bold small" style="color:#0dcaf0;text-wrap-mode: nowrap;">In arrivo/Arrivati</div>
          </div>
        </div>

        <div class="ms-auto ps-3 border-start summary-metrics">
          <div class="d-flex gap-3">
           <div class="summary-metric">
            <div class="summary-metric__title text-muted">Colli scaricati</div>
            <div class="summary-metric__value fw-semibold">{{ totArrivedItems | number }}</div>
            <div class="summary-metric__sub text-muted">
              {{ formatKg(totArrivedWeight) }} • {{ formatM3(totArrivedVolume) }}
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CHIUSO -->
    <div class="col-xl-3 col-lg-4 col-md-6">
      <div class="summary-card summary-card--wide d-flex align-items-center p-3 rounded"
           style="background-color: rgba(25, 135, 84, 0.10);">
        <div class="d-flex align-items-center">
          <i class="fas fa-lock fa-2x" style="color:#198754;"></i>
          <div class="ms-3">
            <div class="fw-bold fs-4" style="color:#198754;">{{ summaryClosed | number }}</div>
            <div class="fw-bold small" style="color:#198754;">Chiusi</div>
          </div>
        </div>

        <div class="ms-auto ps-3 border-start summary-metrics">
          <div class="d-flex gap-3">
            <div class="summary-metric">
              <div class="summary-metric__title text-muted">Colli scaricati</div>
              <div class="summary-metric__value fw-semibold">{{ totClosedItems | number }}</div>
              <div class="summary-metric__sub text-muted">
                {{ formatKg(totClosedWeight) }} • {{ formatM3(totClosedVolume) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

</div>



  <!-- Azioni top tabella -->
  <div class="card mb-4 table-card">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-list header-icon"></i>
          <h3>Borderò</h3>
        </div>

        <div class="controls-container">
          <!-- <button type="button"
                  class="header-action-btn me-1"
                  (click)="printSelectedDDT()"
                  [disabled]="selectedIds.size === 0 || isPrinting"
                  matTooltip="Scarica DDT dei borderò selezionati"
                  matTooltipPosition="below"
                  matTooltipShowDelay="200">
            <i class="fas text-primary"
              [class.fa-file-alt]="!isPrinting"
              [class.fa-spinner]="isPrinting"
              [class.fa-spin]="isPrinting"></i>
          </button> -->

          <button type="button"
                  class="header-action-btn me-1"
                  (click)="printSelectedLinkedTransportDocuments()"
                  [disabled]="selectedIds.size === 0 || isPrinting"
                  matTooltip="Scarica Documenti di Trasporto abbinati ai borderò selezionati (un PDF per viaggio)"
                  matTooltipPosition="below"
                  matTooltipShowDelay="200">
            <i class="fas text-danger"
              [class.fa-file-pdf]="!isPrinting"
              [class.fa-spinner]="isPrinting"
              [class.fa-spin]="isPrinting"></i>
          </button>

          <button type="button"
                  class="header-action-btn me-1"
                  (click)="exportSelected()"
                  [disabled]="selectedIds.size === 0 || isExporting"
                  matTooltip="Scarica Excel selezionati"
                  matTooltipPosition="below"
                  matTooltipShowDelay="200">
            <i class="fas text-success"
              [class.fa-download]="!isExporting"
              [class.fa-spinner]="isExporting"
              [class.fa-spin]="isExporting"></i>
          </button>

          <div class="btn-group btn-group-sm pagination-selector" role="group">
            <button type="button" class="btn"
                    [ngClass]="itemsPerPage === 5 ? 'btn-secondary' : 'btn-outline-secondary'"
                    (click)="setItemsPerPage(5)"
                    matTooltip="5 righe per pagina" matTooltipShowDelay="200">
                5
            </button>
            <button type="button" class="btn"
                    [ngClass]="itemsPerPage === 10 ? 'btn-secondary' : 'btn-outline-secondary'"
                    (click)="setItemsPerPage(10)"
                    matTooltip="10 righe per pagina" matTooltipShowDelay="200">
                10
            </button>
            <button type="button" class="btn"
                    [ngClass]="itemsPerPage === 25 ? 'btn-secondary' : 'btn-outline-secondary'"
                    (click)="setItemsPerPage(25)"
                    matTooltip="25 righe per pagina" matTooltipShowDelay="200">
                25
            </button>
            <button type="button" class="btn"
                    [ngClass]="itemsPerPage === 50 ? 'btn-secondary' : 'btn-outline-secondary'"
                    (click)="setItemsPerPage(50)"
                    matTooltip="50 righe per pagina" matTooltipShowDelay="200">
                50
            </button>
            <button type="button" class="btn"
                    [ngClass]="itemsPerPage === 100 ? 'btn-secondary' : 'btn-outline-secondary'"
                    (click)="setItemsPerPage(100)"
                    matTooltip="100 righe per pagina" matTooltipShowDelay="200">
                100
            </button>
          </div>

          <span class="badge bg-light text-muted">
            <i class="fas fa-list me-1"></i> {{ filteredLists.length }}
          </span>
        </div>
      </div>
    </div>

    <div class="card-body p-0 table-card-body">

      <div class="table-responsive" [class.no-vertical-scroll]="isFirstRowDropdownOpen()" (click)="closeAllPopups()">
        <table class="table table-hover mb-0 fixed-table">
 <thead class="table-light">
  <tr>
    <th style="min-width: 40px;" class="text-center">
      <input type="checkbox" class="form-check-input"
             [checked]="areAllSelected()"
             (change)="areAllSelected() ? deselectAll() : selectAll()">
    </th>

    <th style="min-width: 40px;">#</th>

    <!-- TIPO -->
    <th scope="col" class="th-sort-filter" style="min-width: 100px;">
      <span class="th-title" (click)="toggleFilterPopup('type', $event)">
        Tipo
        <i class="bi bi-funnel ms-1" [class.text-primary]="filterSelected['type']?.size"></i>
      </span>

      <i class="bi ms-2 th-sort-ico"
         (click)="setSort('type'); $event.stopPropagation()"
         [ngClass]="getSortIcon('type')"></i>

      <div *ngIf="filtersOpen['type']" class="table-filter-popup" (click)="$event.stopPropagation()">
        <input class="form-control form-control-sm mb-2"
               placeholder="Cerca..."
               [(ngModel)]="filterSearch['type']"
               (input)="rebuildFilterList('type')" />

        <label class="d-flex align-items-center gap-2 mb-2">
          <input #allType type="checkbox"
                 [checked]="(filterSelected['type']?.size || 0) === (filterValuesAll['type']?.length || 0)"
                 (change)="onToggleAll('type', allType.checked)" />
          <span>Seleziona tutto</span>
        </label>

        <div class="popup-list">
          <label class="d-flex align-items-center gap-2 mb-1" *ngFor="let v of filterValuesShown['type']">
            <input #chkType type="checkbox"
                   [checked]="isValueSelected('type', v)"
                   (change)="toggleFilterValue('type', v, chkType.checked)" />
            <span class="text-truncate" style="max-width: 220px;">{{ v }}</span>
          </label>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-2">
          <button class="btn btn-sm btn-light" (click)="resetFilter('type')">Reset</button>
          <button class="btn btn-sm btn-primary" (click)="applyFilter('type')">Applica</button>
        </div>
      </div>
    </th>

    <!-- CODICE -->
    <th scope="col" class="th-sort-filter col-code">
      <span class="th-title" (click)="toggleFilterPopup('code', $event)">
        Codice
        <i class="bi bi-funnel ms-1" [class.text-primary]="filterSelected['code']?.size"></i>
      </span>

      <i class="bi ms-2 th-sort-ico"
         (click)="setSort('code'); $event.stopPropagation()"
         [ngClass]="getSortIcon('code')"></i>

      <div *ngIf="filtersOpen['code']" class="table-filter-popup" (click)="$event.stopPropagation()">
        <input class="form-control form-control-sm mb-2"
               placeholder="Cerca..."
               [(ngModel)]="filterSearch['code']"
               (input)="rebuildFilterList('code')" />

        <label class="d-flex align-items-center gap-2 mb-2">
          <input #allCode type="checkbox"
                 [checked]="(filterSelected['code']?.size || 0) === (filterValuesAll['code']?.length || 0)"
                 (change)="onToggleAll('code', allCode.checked)" />
          <span>Seleziona tutto</span>
        </label>

        <div class="popup-list">
          <label class="d-flex align-items-center gap-2 mb-1" *ngFor="let v of filterValuesShown['code']">
            <input #chkCode type="checkbox"
                   [checked]="isValueSelected('code', v)"
                   (change)="toggleFilterValue('code', v, chkCode.checked)" />
            <span class="text-truncate" style="max-width: 220px;">{{ v }}</span>
          </label>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-2">
          <button class="btn btn-sm btn-light" (click)="resetFilter('code')">Reset</button>
          <button class="btn btn-sm btn-primary" (click)="applyFilter('code')">Applica</button>
        </div>
      </div>
    </th>

    <!-- CREATO IL (solo sort) -->
    <th>
      Creato il
      <i class="bi ms-2 th-sort-ico"
         (click)="setSort('createdAt')"
         [ngClass]="getSortIcon('createdAt')"></i>
    </th>

    <!-- CREATO DA (Spare Parts / Atlas) -->
    <th scope="col" class="th-sort-filter d-none d-md-table-cell">
      <span class="th-title" (click)="toggleFilterPopup('createdByUi', $event)">
        Creato da
        <i class="bi bi-funnel ms-1" [class.text-primary]="filterSelected['createdByUi']?.size"></i>
      </span>

      <i class="bi ms-2 th-sort-ico"
         (click)="setSort('createdByUi'); $event.stopPropagation()"
         [ngClass]="getSortIcon('createdByUi')"></i>

      <div *ngIf="filtersOpen['createdByUi']" class="table-filter-popup" (click)="$event.stopPropagation()">
        <input class="form-control form-control-sm mb-2"
               placeholder="Cerca..."
               [(ngModel)]="filterSearch['createdByUi']"
               (input)="rebuildFilterList('createdByUi')" />

        <label class="d-flex align-items-center gap-2 mb-2">
          <input #allCb type="checkbox"
                 [checked]="(filterSelected['createdByUi']?.size || 0) === (filterValuesAll['createdByUi']?.length || 0)"
                 (change)="onToggleAll('createdByUi', allCb.checked)" />
          <span>Seleziona tutto</span>
        </label>

        <div class="popup-list">
          <label class="d-flex align-items-center gap-2 mb-1" *ngFor="let v of filterValuesShown['createdByUi']">
            <input #chkCb type="checkbox"
                   [checked]="isValueSelected('createdByUi', v)"
                   (change)="toggleFilterValue('createdByUi', v, chkCb.checked)" />
            <span class="text-truncate" style="max-width: 220px;">{{ v }}</span>
          </label>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-2">
          <button class="btn btn-sm btn-light" (click)="resetFilter('createdByUi')">Reset</button>
          <button class="btn btn-sm btn-primary" (click)="applyFilter('createdByUi')">Applica</button>
        </div>
      </div>
    </th>

    <th>
      Partito il
      <i class="bi ms-2 th-sort-ico"
         (click)="setSort('validatedAt')"
         [ngClass]="getSortIcon('validatedAt')"></i>
    </th>

    <!-- VETTORE -->
    <th scope="col" class="th-sort-filter d-none d-lg-table-cell" style="min-width: 120px;">
      <span class="th-title" (click)="toggleFilterPopup('carrier', $event)">
        Vettore
        <i class="bi bi-funnel ms-1" [class.text-primary]="filterSelected['carrier']?.size"></i>
      </span>

      <i class="bi ms-2 th-sort-ico"
         (click)="setSort('carrier'); $event.stopPropagation()"
         [ngClass]="getSortIcon('carrier')"></i>

      <div *ngIf="filtersOpen['carrier']" class="table-filter-popup" (click)="$event.stopPropagation()">
        <input class="form-control form-control-sm mb-2"
               placeholder="Cerca..."
               [(ngModel)]="filterSearch['carrier']"
               (input)="rebuildFilterList('carrier')" />

        <label class="d-flex align-items-center gap-2 mb-2">
          <input #allCar type="checkbox"
                 [checked]="(filterSelected['carrier']?.size || 0) === (filterValuesAll['carrier']?.length || 0)"
                 (change)="onToggleAll('carrier', allCar.checked)" />
          <span>Seleziona tutto</span>
        </label>

        <div class="popup-list">
          <label class="d-flex align-items-center gap-2 mb-1" *ngFor="let v of filterValuesShown['carrier']">
            <input #chkCar type="checkbox"
                   [checked]="isValueSelected('carrier', v)"
                   (change)="toggleFilterValue('carrier', v, chkCar.checked)" />
            <span class="text-truncate" style="max-width: 220px;">{{ v }}</span>
          </label>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-2">
          <button class="btn btn-sm btn-light" (click)="resetFilter('carrier')">Reset</button>
          <button class="btn btn-sm btn-primary" (click)="applyFilter('carrier')">Applica</button>
        </div>
      </div>
    </th>

    <!-- TARGA -->
    <th scope="col" class="th-sort-filter d-none d-lg-table-cell">
      <span class="th-title" (click)="toggleFilterPopup('plate', $event)">
        Targa
        <i class="bi bi-funnel ms-1" [class.text-primary]="filterSelected['plate']?.size"></i>
      </span>

      <i class="bi ms-2 th-sort-ico"
         (click)="setSort('plate'); $event.stopPropagation()"
         [ngClass]="getSortIcon('plate')"></i>

      <div *ngIf="filtersOpen['plate']" class="table-filter-popup" (click)="$event.stopPropagation()">
        <input class="form-control form-control-sm mb-2"
               placeholder="Cerca..."
               [(ngModel)]="filterSearch['plate']"
               (input)="rebuildFilterList('plate')" />

        <label class="d-flex align-items-center gap-2 mb-2">
          <input #allPlate type="checkbox"
                 [checked]="(filterSelected['plate']?.size || 0) === (filterValuesAll['plate']?.length || 0)"
                 (change)="onToggleAll('plate', allPlate.checked)" />
          <span>Seleziona tutto</span>
        </label>

        <div class="popup-list">
          <label class="d-flex align-items-center gap-2 mb-1" *ngFor="let v of filterValuesShown['plate']">
            <input #chkPlate type="checkbox"
                   [checked]="isValueSelected('plate', v)"
                   (change)="toggleFilterValue('plate', v, chkPlate.checked)" />
            <span class="text-truncate" style="max-width: 220px;">{{ v }}</span>
          </label>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-2">
          <button class="btn btn-sm btn-light" (click)="resetFilter('plate')">Reset</button>
          <button class="btn btn-sm btn-primary" (click)="applyFilter('plate')">Applica</button>
        </div>
      </div>
    </th>

    <!-- MAGAZZINO PARTENZA -->
    <th scope="col" class="th-sort-filter d-none d-lg-table-cell" style="min-width: 140px;">
      <span class="th-title" (click)="toggleFilterPopup('warehouse', $event)">
        Magazzino partenza
        <i class="bi bi-funnel ms-1" [class.text-primary]="filterSelected['warehouse']?.size"></i>
      </span>

      <i class="bi ms-2 th-sort-ico"
         (click)="setSort('warehouse'); $event.stopPropagation()"
         [ngClass]="getSortIcon('warehouse')"></i>

      <div *ngIf="filtersOpen['warehouse']" class="table-filter-popup" (click)="$event.stopPropagation()">
        <input class="form-control form-control-sm mb-2"
               placeholder="Cerca..."
               [(ngModel)]="filterSearch['warehouse']"
               (input)="rebuildFilterList('warehouse')" />

        <label class="d-flex align-items-center gap-2 mb-2">
          <input #allWh type="checkbox"
                 [checked]="(filterSelected['warehouse']?.size || 0) === (filterValuesAll['warehouse']?.length || 0)"
                 (change)="onToggleAll('warehouse', allWh.checked)" />
          <span>Seleziona tutto</span>
        </label>

        <div class="popup-list">
          <label class="d-flex align-items-center gap-2 mb-1" *ngFor="let v of filterValuesShown['warehouse']">
            <input #chkWh type="checkbox"
                   [checked]="isValueSelected('warehouse', v)"
                   (change)="toggleFilterValue('warehouse', v, chkWh.checked)" />
            <span class="text-truncate" style="max-width: 220px;">{{ v }}</span>
          </label>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-2">
          <button class="btn btn-sm btn-light" (click)="resetFilter('warehouse')">Reset</button>
          <button class="btn btn-sm btn-primary" (click)="applyFilter('warehouse')">Applica</button>
        </div>
      </div>
    </th>

    <!-- MAGAZZINO ARRIVO -->
    <th scope="col" class="th-sort-filter col-code">
      <span class="th-title" (click)="toggleFilterPopup('warehouseTo', $event)">
        Magazzino Arrivo
        <i class="bi bi-funnel ms-1" [class.text-primary]="filterSelected['warehouseTo']?.size"></i>
      </span>

      <i class="bi ms-2 th-sort-ico"
         (click)="setSort('warehouseTo'); $event.stopPropagation()"
         [ngClass]="getSortIcon('warehouseTo')"></i>

      <div *ngIf="filtersOpen['warehouseTo']" class="table-filter-popup" (click)="$event.stopPropagation()">
        <input class="form-control form-control-sm mb-2"
               placeholder="Cerca..."
               [(ngModel)]="filterSearch['warehouseTo']"
               (input)="rebuildFilterList('warehouseTo')" />

        <label class="d-flex align-items-center gap-2 mb-2">
          <input #allWh type="checkbox"
                 [checked]="(filterSelected['warehouseTo']?.size || 0) === (filterValuesAll['warehouseTo']?.length || 0)"
                 (change)="onToggleAll('warehouseTo', allWh.checked)" />
          <span>Seleziona tutto</span>
        </label>

        <div class="popup-list">
          <label class="d-flex align-items-center gap-2 mb-1" *ngFor="let v of filterValuesShown['warehouseTo']">
            <input #chkWh type="checkbox"
                   [checked]="isValueSelected('warehouseTo', v)"
                   (change)="toggleFilterValue('warehouseTo', v, chkWh.checked)" />
            <span class="text-truncate" style="max-width: 220px;">{{ v }}</span>
          </label>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-2">
          <button class="btn btn-sm btn-light" (click)="resetFilter('warehouseTo')">Reset</button>
          <button class="btn btn-sm btn-primary" (click)="applyFilter('warehouseTo')">Applica</button>
        </div>
      </div>
    </th>

    <!-- STATO -->
    <th scope="col" class="th-sort-filter text-start">
      <span class="th-title" (click)="toggleFilterPopup('status', $event)">
        Stato
        <i class="bi bi-funnel ms-1" [class.text-primary]="filterSelected['status']?.size"></i>
      </span>

      <i class="bi ms-2 th-sort-ico"
         (click)="setSort('status'); $event.stopPropagation()"
         [ngClass]="getSortIcon('status')"></i>

      <div *ngIf="filtersOpen['status']" class="table-filter-popup" (click)="$event.stopPropagation()">
        <input class="form-control form-control-sm mb-2"
               placeholder="Cerca..."
               [(ngModel)]="filterSearch['status']"
               (input)="rebuildFilterList('status')" />

        <label class="d-flex align-items-center gap-2 mb-2">
          <input #allSt type="checkbox"
                 [checked]="(filterSelected['status']?.size || 0) === (filterValuesAll['status']?.length || 0)"
                 (change)="onToggleAll('status', allSt.checked)" />
          <span>Seleziona tutto</span>
        </label>

        <div class="popup-list">
          <label class="d-flex align-items-center gap-2 mb-1" *ngFor="let v of filterValuesShown['status']">
            <input #chkSt type="checkbox"
                   [checked]="isValueSelected('status', v)"
                   (change)="toggleFilterValue('status', v, chkSt.checked)" />
            <span class="text-truncate" style="max-width: 220px;">{{ v }}</span>
          </label>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-2">
          <button class="btn btn-sm btn-light" (click)="resetFilter('status')">Reset</button>
          <button class="btn btn-sm btn-primary" (click)="applyFilter('status')">Applica</button>
        </div>
      </div>
    </th>

    <!-- COLLI (solo sort) -->
    <th class="text-start d-none d-lg-table-cell col-parcels">
      Colli
      <i class="bi ms-2 th-sort-ico"></i>
    </th>

    <!-- EXTRA -->
    <th scope="col" class="th-sort-filter text-start">
      <span class="th-title" (click)="toggleFilterPopup('extra', $event)">
        EXTRA
        <i class="bi bi-funnel ms-1" [class.text-primary]="filterSelected['extra']?.size"></i>
      </span>

      <i class="bi ms-2 th-sort-ico"
         (click)="setSort('extra'); $event.stopPropagation()"
         [ngClass]="getSortIcon('extra')"></i>

      <div *ngIf="filtersOpen['extra']" class="table-filter-popup" (click)="$event.stopPropagation()">
        <input class="form-control form-control-sm mb-2"
               placeholder="Cerca..."
               [(ngModel)]="filterSearch['extra']"
               (input)="rebuildFilterList('extra')" />

        <label class="d-flex align-items-center gap-2 mb-2">
          <input #allEx type="checkbox"
                 [checked]="(filterSelected['extra']?.size || 0) === (filterValuesAll['extra']?.length || 0)"
                 (change)="onToggleAll('extra', allEx.checked)" />
          <span>Seleziona tutto</span>
        </label>

        <div class="popup-list">
          <label class="d-flex align-items-center gap-2 mb-1" *ngFor="let v of filterValuesShown['extra']">
            <input #chkEx type="checkbox"
                   [checked]="isValueSelected('extra', v)"
                   (change)="toggleFilterValue('extra', v, chkEx.checked)" />
            <span class="text-truncate" style="max-width: 220px;">{{ v }}</span>
          </label>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-2">
          <button class="btn btn-sm btn-light" (click)="resetFilter('extra')">Reset</button>
          <button class="btn btn-sm btn-primary" (click)="applyFilter('extra')">Applica</button>
        </div>
      </div>
    </th>

    <!-- PTV -->
    <th scope="col" class="th-sort-filter text-start">
      <span class="th-title" (click)="toggleFilterPopup('ptv', $event)">
        PTV
        <i class="bi bi-funnel ms-1" [class.text-primary]="filterSelected['ptv']?.size"></i>
      </span>

      <i class="bi ms-2 th-sort-ico"
         (click)="setSort('ptv'); $event.stopPropagation()"
         [ngClass]="getSortIcon('ptv')"></i>

      <div *ngIf="filtersOpen['ptv']" class="table-filter-popup" (click)="$event.stopPropagation()">
        <input class="form-control form-control-sm mb-2"
               placeholder="Cerca..."
               [(ngModel)]="filterSearch['ptv']"
               (input)="rebuildFilterList('ptv')" />

        <label class="d-flex align-items-center gap-2 mb-2">
          <input #allPtv type="checkbox"
                 [checked]="(filterSelected['ptv']?.size || 0) === (filterValuesAll['ptv']?.length || 0)"
                 (change)="onToggleAll('ptv', allPtv.checked)" />
          <span>Seleziona tutto</span>
        </label>

        <div class="popup-list">
          <label class="d-flex align-items-center gap-2 mb-1" *ngFor="let v of filterValuesShown['ptv']">
            <input #chkPtv type="checkbox"
                   [checked]="isValueSelected('ptv', v)"
                   (change)="toggleFilterValue('ptv', v, chkPtv.checked)" />
            <span class="text-truncate" style="max-width: 220px;">{{ v }}</span>
          </label>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-2">
          <button class="btn btn-sm btn-light" (click)="resetFilter('ptv')">Reset</button>
          <button class="btn btn-sm btn-primary" (click)="applyFilter('ptv')">Applica</button>
        </div>
      </div>
    </th>

    <th></th>
  </tr>
</thead>


          <tbody>
  <tr *ngFor="let ll of filteredLists   | paginate: { id: 'loading-lists', itemsPerPage: itemsPerPage, currentPage: currentPage }; trackBy: trackByLoadingListId; let i = index" class="align-middle">
    <td class="text-center">
      <input type="checkbox" class="form-check-input"
             [checked]="isSelected(ll.loadingListId)"
             (change)="toggleSelection(ll.loadingListId)">
    </td>

    <td class="text-muted">{{ (currentPage - 1) * itemsPerPage + i + 1 }}</td>

    <td class="text-start">
      <span class="badge d-inline-flex align-items-center gap-1"
            [ngStyle]="{
              backgroundColor: getLoadingListTypeMeta(ll).bg,
              color: getLoadingListTypeMeta(ll).color
            }">

        <i class="fa"
          [ngClass]="getLoadingListTypeMeta(ll).icon"
          [ngStyle]="{ color: getLoadingListTypeMeta(ll).color }">
        </i>

        {{ getLoadingListTypeMeta(ll).label }}
      </span>
    </td>

    <td class="fw-medium">
      <div class="d-flex flex-column code-cell">
        <span class="clickable-code" (click)="openDetail(ll)">
          {{ ll.loadingListCode }}
        </span>

        <span *ngIf="ll.loadingListTourRoutingGroups"
              class="tour-groups text-muted small"
              matTooltip="{{ ll.loadingListTourRoutingGroups }}"
              matTooltipPosition="above"
              matTooltipShowDelay="300">
          <i class="fas fa-layer-group me-1"></i>
          <span class="tour-groups-text">{{ ll.loadingListTourRoutingGroups }}</span>
        </span>

        <span *ngFor="let tourRouting of ll.loadingListTourRoutingsWithoutGroup" class="tour-without-group-badge">
          <i class="fas fa-route"></i>
          {{ tourRouting }}
        </span>

        <span *ngIf="ll.loadingListTripCode" class="link-trip-badge">
          <i class="fas fa-link"></i>
          {{ ll.loadingListTripCode }}
        </span>
      </div>
    </td>

    <td class="d-none d-md-table-cell">
      {{ ll.loadingListCreatedAt | date:'dd/MM/yy HH:mm' }}
    </td>

    <td class="text-start">
      <i *ngIf="ll.loadingListCreatedBy === 'SPARE PARTS'"
        class="fa-solid fa-mobile-screen-button"
        matTooltip="Spare Parts (Palmare)">
      </i>

      <i *ngIf="ll.loadingListCreatedBy !== 'SPARE PARTS'"
        class="fa-solid fa-desktop"
        matTooltip="Atlas (PC)">
      </i>
    </td>

    <td class="d-none d-md-table-cell">
      {{ ll.loadingListValidatedAt | date:'dd/MM/yy HH:mm' }}
    </td>

    <td class="d-none d-lg-table-cell">
      <div class="d-flex flex-column">
        <span>{{ getCarrierName(ll.loadingListCarrierCode) }}</span>
      </div>
    </td>

    <td class="d-none d-lg-table-cell">{{ ll.loadingListPlateNo }}</td>

    <td class="d-none d-lg-table-cell">
      <div class="d-flex flex-column">
        <span>{{ getWarehouseName(ll.loadingListWarehouseCode) }}</span>
        <span class="text-muted small" *ngIf="getWarehouseShortName(ll.loadingListWarehouseCode)">
          {{ getWarehouseShortName(ll.loadingListWarehouseCode) }}
        </span>
      </div>
    </td>

    <td class="d-none d-lg-table-cell">
      <div class="d-flex flex-column code-cell">
        <span *ngIf="ll.loadingListWarehousesToName"
                [matTooltip]="ll.loadingListWarehousesToName + '\n\n' + '---------------' + ll.loadingListWarehousesToShortName"
                matTooltipPosition="above"
                matTooltipShowDelay="300">
          <div class="d-flex flex-column">
            <span>{{ ll.loadingListWarehousesToName }}</span>
            <span class="text-muted small" *ngIf="ll.loadingListWarehousesToShortName">
              {{ ll.loadingListWarehousesToShortName }}
            </span>
          </div>
        </span>
      </div>
    </td>


    <td class="text-start">
      <span class="badge" [ngStyle]="getLoadingListStatusStyle(ll.loadingListStatus)">
         {{ getLoadingListStatusLabel(ll.loadingListStatus) }}
      </span>
    </td>

    <!-- <td class="text-end d-none d-lg-table-cell" style="min-width: 140px;">
      <div class="d-flex flex-column align-items-end gap-1">
        <div class="d-flex align-items-center gap-2">
          <span class="fw-semibold">{{ formatRatio(ll.loadingListLoadedCount, ll.loadingListItemsCount) }}</span>
          <span class="text-muted small" *ngIf="(ll.loadingListItemsCount ?? 0) > 0">
            {{ getPercent(ll.loadingListLoadedCount, ll.loadingListItemsCount) }}%
          </span>
        </div>

        <div class="progress w-100" style="height: 6px;">
          <div class="progress-bar"
               role="progressbar"
               [style.width.%]="getPercent(ll.loadingListLoadedCount, ll.loadingListItemsCount)">
          </div>
        </div>

        <div class="text-muted small" >
          {{ formatKg(ll.loadingListLoadedWeight) }} • {{ formatM3(ll.loadingListLoadedVolume) }}
        </div>
      </div>
    </td>

    <td class="text-end d-none d-lg-table-cell" style="min-width: 140px;">
      <div class="d-flex flex-column align-items-end gap-1">
        <div class="d-flex align-items-center gap-2">
          <span class="fw-semibold">{{ formatRatio(ll.loadingListUnloadedCount, ll.loadingListItemsCount) }}</span>
          <span class="text-muted small" *ngIf="(ll.loadingListItemsCount ?? 0) > 0">
            {{ getPercent(ll.loadingListUnloadedCount, ll.loadingListItemsCount) }}%
          </span>
        </div>

        <div class="progress w-100" style="height: 6px;">
          <div class="progress-bar"
               role="progressbar"
               [style.width.%]="getPercent(ll.loadingListUnloadedCount, ll.loadingListItemsCount)">
          </div>
        </div>

        <div class="text-muted small" >
          {{ formatKg(ll.loadingListUnloadedWeight) }} • {{ formatM3(ll.loadingListUnloadedVolume) }}
        </div>
      </div>
    </td> -->

    <td class="text-end d-none d-lg-table-cell" style="min-width: 170px;">
      <div class="d-flex flex-column align-items-end gap-1">

        <div class="d-flex align-items-between gap-2">
          <span class="badge bg-light text-muted">
            {{ ll.uiType == 'ARRIVAL' ? 'SCARICATI' : ll.uiType == 'LINE_CHECK' ? 'CONTROLLATI' : 'CARICATI' }}
          </span>

          <div class="d-flex align-items-center gap-2">
            <span class="fw-semibold">
              {{ formatRatio(getShownCount(ll), ll.loadingListItemsCount) }}
            </span>

            <span class="text-muted small" *ngIf="(ll.loadingListItemsCount ?? 0) > 0">
              {{ getPercent(getShownCount(ll), ll.loadingListItemsCount) }}%
            </span>
          </div>
        </div>

        <div class="progress w-100" style="height: 6px;">
          <div class="progress-bar"
              role="progressbar"
              [style.width.%]="getPercent(getShownCount(ll), ll.loadingListItemsCount)">
          </div>
        </div>

        <div class="text-muted small">
          {{ formatKg(getShownWeight(ll)) }} • {{ formatM3(getShownVolume(ll)) }}
        </div>

      </div>
    </td>

    <td class="text-start">
      <span *ngIf="ll.loadingListIsExtra === 'Y'" class="badge bg-primary">Sì</span>
      <!-- <span *ngIf="ll.loadingListIsExtra === 'N' || ll.loadingListIsExtra === '' || ll.loadingListIsExtra == null " class="badge bg-secondary">No</span> -->
    </td>

    <td class="text-start">
      <span *ngIf="!ll.loadingListIsInternal" class="badge bg-primary">Sì</span>
      <!-- <span *ngIf="ll.loadingListIsInternal" class="badge bg-secondary">No</span> -->
    </td>

    <!-- <td>
      <div class="d-flex gap-1">
        <button type="button" class="header-action-btn"
                (click)="openDetail(ll)" title="Apri">
          <i class="fas fa-folder-open"></i>
        </button>
      </div>
    </td> -->
    <td class="text-start actions-cell" [class.first-row-actions]="i === 0" (click)="$event.stopPropagation()">
      <div class="dropdown">
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary dropdown-toggle"
          [attr.id]="'dropdownMenuButton' + ll.loadingListId"
          (click)="toggleDropdown(ll.loadingListId, $event)">
          <i class="bi bi-three-dots-vertical"></i>
        </button>

        <ul class="dropdown-menu dropdown-menu-actions"
            [class.show]="isDropdownOpen(ll.loadingListId)"
            [ngStyle]="getDropdownStyle(ll.loadingListId)"
            [attr.aria-labelledby]="'dropdownMenuButton' + ll.loadingListId"
            (click)="$event.stopPropagation()">

          <li>
            <a class="dropdown-item"
              href="javascript:void(0)"
              (click)="openDetail(ll); closeAllDropdowns()">
              <i class="bi bi-eye me-2"></i> Apri e modifica
            </a>
          </li>
          <li>
            <a class="dropdown-item"
              href="javascript:void(0)"
              [class.disabled]="!ll.loadingListTripId || isPrinting"
              (click)="ll.loadingListTripId && !isPrinting && printLinkedTransportDocuments(ll); closeAllDropdowns()">
              <i class="bi bi-filetype-pdf me-2"></i> Scarica Doc. di Trasporto abbinati
            </a>
          </li>
          <li>
            <a class="dropdown-item"
              href="javascript:void(0)"
              (click)="printDDT(ll.loadingListId); closeAllDropdowns()">
              <i class="bi bi-file-text me-2"></i> Scarica DDT 
            </a>
          </li>
          <li>
            <a class="dropdown-item text-danger"
              href="javascript:void(0)"
              [class.disabled]="ll.loadingListStatus !== 'DRAFT' && ll.loadingListStatus !== 'PREPARED'"
              (click)="(ll.loadingListStatus === 'DRAFT' || ll.loadingListStatus === 'PREPARED') && openDeletePopup(ll); closeAllDropdowns()">
              <i class="bi bi-trash me-2"></i> Elimina
            </a>
          </li>

          <!-- opzionali -->
          <!--
          <li><hr class="dropdown-divider"></li>
          <li>
            <a class="dropdown-item"
              href="javascript:void(0)"
              (click)="printSingle(ll); closeAllDropdowns()">
              <i class="bi bi-filetype-pdf me-2"></i> Stampa PDF
            </a>
          </li>
          -->
        </ul>
      </div>
    </td>

  </tr>

  <tr *ngIf="filteredLists.length === 0 && !isLoading">
    <td colspan="14" class="text-center py-4 text-muted">
      <i class="fas fa-inbox fa-2x mb-2 d-block"></i>
      Nessun borderò trovato
    </td>
  </tr>
</tbody>

        </table>

        <div class="d-flex justify-content-end align-items-center p-3 border-top">
                <pagination-controls
                    *ngIf="(filteredLists?.length || 0) > 0"
                    id="loading-lists"
                    [maxSize]="5"
                    [autoHide]="true"
                    [responsive]="true"
                    previousLabel="←"
                    nextLabel="→"
                    class="d-flex justify-content-end mt-0"
                    (pageChange)="onLoadingListsPageChange($event)">
                </pagination-controls>
            </div>
      </div>
    </div>
  </div>

  <!-- Drawer/Modal dettaglio -->
  <app-loading-list-items
    [visible]="isDetailVisible"
    [loadingList]="selectedLoadingList"
    (closed)="closeDetail()">
  </app-loading-list-items>

</div>

<ng-template #denied>
  <div class="text-center py-5">
    <i class="fas fa-lock fa-3x text-muted mb-3"></i>
    <h5 class="text-muted">Accesso negato</h5>
  </div>
</ng-template>

<!-- DELETE POPUP (stile tuo) -->
<div class="popup-overlay" *ngIf="showDeletePopup" (click)="closeDeletePopup()">
  <div class="popup-content delete-popup" (click)="$event.stopPropagation()">

    <div class="popup-header">
      <h2 class="popup-title ">
        <i class="fas fa-trash me-2"></i>
        Elimina Borderò
      </h2>

      <button type="button" class="btn-close" (click)="closeDeletePopup()" aria-label="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">
      <div class="alert alert-light border mb-3">
        Sicuro di voler eliminare il borderò
        <b class="ms-1">{{ deleteTarget?.loadingListCode || deleteTarget?.loadingListId }}</b> ?
      </div>

      <div class="mb-2 text-muted small">
        <i class="fas fa-info-circle me-1"></i>
        L’operazione non è reversibile.
      </div>

      <div class="mt-3" *ngIf="requireDeleteTextConfirm">
        <label class="form-label">Scrivi <b>ELIMINA</b> per confermare</label>
        <input type="text"
               class="form-control"
               [(ngModel)]="deleteConfirmText"
               placeholder="ELIMINA">
      </div>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-secondary" (click)="closeDeletePopup()" [disabled]="deleting">
          Annulla
        </button>

        <button type="button"
                class="btn btn-danger"
                (click)="confirmDeletePopup()"
                [disabled]="deleting || (requireDeleteTextConfirm && deleteConfirmText !== 'ELIMINA')">
          <span *ngIf="!deleting">
            <i class="fas fa-trash me-2"></i>Elimina
          </span>
          <span *ngIf="deleting">
            <i class="fas fa-spinner fa-spin me-2"></i>Eliminazione...
          </span>
        </button>
      </div>
    </div>

  </div>
</div>